export default "__VITE_ASSET__DsACtykP__"